var map = {
	"./bring": 2153,
	"./bring.png": 2153,
	"./dao": 2154,
	"./dao.svg": 2154,
	"./gls": 2155,
	"./gls.jpg": 2155,
	"./pdk": 2156,
	"./pdk.png": 2156,
	"./uni": 2157,
	"./uni.png": 2157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2496;